// 为数据mock提供了两个时机
// 1、在统一注册的register方法中,对path参数添加'/mock'前缀，
// 如：register('config', 'post', `/mock${baseUrl}/config`);
// 这种mock方法会让该接口所以调用都走数据mock
//
// 2、在使用是在方法名称后面添加Mock
// 如：Api.config_Mock
// 这种mock方法只会在本次调用时使用mock数据，并不会影响其他的config调用（Api.config）
//
// 注册完需要mock的接口后，只需要在mock/index文件下做路由处理就行。

import { baseUrl, cepBaseUrl } from './config';
import util from '@/util';

const methods = [];
methods.install = function (Api) {
  const sent = (path, type, normalize, data, config) => {
    return Api[type](path, data, config).then(res => {
      if (normalize && typeof normalize === 'function') {
        // 后端数据返回的数据结构改变时可以用该方法适配
        normalize(res);
      }
      return res;
    });
  };

  this.forEach(method => {
    const { methodName, type, publicPath, cepPath, normalize } = method;
    const urlParams = util.getUrlParams() || {};
    const isPublic = !!urlParams.identifier;

    let path = isPublic ? publicPath : cepPath;
    urlParams.isEM6 && (path = path.replace('EM1', 'EM6'));

    Api[methodName] = (data = {}, config) => {
      if (isPublic) {
        data.identifier = urlParams.identifier;
        data.fsEa = urlParams.ea;
      }
      return sent(path, type, normalize, data, config);
    };
    // 独立的mock方法
    Api[methodName + '_Mock'] = (...args) => {
      // 匹配/mock/开头
      path.match(/^\/mock\//) || (path = '/mock' + path);
      return sent(path, type, normalize, ...args);
    };
    // 强制去除mock方法
    Api[methodName + '_NoMock'] = (...args) => {
      path = path.replace(/^\/mock\//, '/');
      return sent(path, type, normalize, ...args);
    };
  });
};

// 记录注册的路由配置
const register = ({ methodName = '', type = '', publicPath = '', cepPath = '', normalize = '' } = {}) => {
  methods.push({ methodName, type, publicPath, cepPath, normalize });
};

// 获取知识库配置
register({
  methodName: 'config',
  type: 'post',
  publicPath: `${baseUrl}/config`,
  cepPath: `${cepBaseUrl}/config`,
});
// 获取知识记录
register({
  methodName: 'queryKnowledgeRecordH5',
  type: 'post',
  publicPath: `${baseUrl}/queryKnowledgeRecordH5`,
  cepPath: `${cepBaseUrl}/queryKnowledgeRecordH5`,
});
// 获取知识记录阅读、帮助等计数
register({
  methodName: 'updateKnowledgeRecordCount',
  type: 'post',
  publicPath: `${baseUrl}/updateKnowledgeRecordCount`,
  cepPath: `${cepBaseUrl}/updateKnowledgeRecordCount`,
});
// 取消帮助计数
register({
  methodName: 'cancelKnowledgeRecordHelpful',
  type: 'post',
  publicPath: `${baseUrl}/cancelKnowledgeRecordHelpful`,
  cepPath: `${cepBaseUrl}/cancelKnowledgeRecordHelpful`,
});
// 获取知识详情
register({
  methodName: 'queryKnowledgeRecordDetail',
  type: 'post',
  publicPath: `${baseUrl}/queryKnowledgeRecordDetail`,
  cepPath: `${cepBaseUrl}/queryKnowledgeRecordDetail`,
});
// 获取最新最热
register({
  methodName: 'queryMaxKnowledge',
  type: 'post',
  publicPath: `${baseUrl}/queryMaxKnowledge`,
  cepPath: `${cepBaseUrl}/queryMaxKnowledge`,
});
// 获取知识分类
register({
  methodName: 'queryKnowledgeBaseList',
  type: 'post',
  publicPath: `${baseUrl}/queryKnowledgeBaseList`,
  cepPath: `/FHH/EM1HESERVICE2/eservice/knowledgeConfig/queryKnowledgeBaseList`,
});
// 查询知识库详情
register({
  methodName: 'viewKnowledgeBase',
  type: 'post',
  publicPath: `${baseUrl}/viewKnowledgeBase`,
  cepPath: `/FHH/EM1HESERVICE2/eservice/knowledgeConfig/viewKnowledgeBase`,
});
// 获取知识库列表
register({
  methodName: 'queryCategory',
  type: 'post',
  publicPath: `${baseUrl}/queryCategory`,
  cepPath: `${cepBaseUrl}/queryCategory`,
});
// 获取知识空间中的分类列表
register({
  methodName: 'list_new',
  type: 'post',
  publicPath: `/FHH/EM1HNCRM/API/v1/object/knowledge_category/service/list_new`,
  cepPath: `/FHH/EM1HNCRM/API/v1/object/knowledge_category/service/list_new`,
});
// 添加知识分类
register({
  methodName: 'addKnowledgeCategory',
  type: 'post',
  publicPath: `/FHH/EM1HNCRM/API/v1/object/knowledge_category/service/add`,
  cepPath: `/FHH/EM1HNCRM/API/v1/object/knowledge_category/service/add`,
});
// 更新知识分类
register({
  methodName: 'updateKnowledgeCategory',
  type: 'post',
  publicPath: `/FHH/EM1HNCRM/API/v1/object/knowledge_category/service/update`,
  cepPath: `/FHH/EM1HNCRM/API/v1/object/knowledge_category/service/update`,
});
// 删除知识分类
register({
  methodName: 'deleteKnowledgeCategory',
  type: 'post',
  publicPath: `/FHH/EM1HNCRM/API/v1/object/knowledge_category/service/delete`,
  cepPath: `/FHH/EM1HNCRM/API/v1/object/knowledge_category/service/delete`,
});
// 获取知识空间中的分类列表
register({
  methodName: 'saveScene',
  type: 'post',
  publicPath: `/FHH/EM1HESERVICE2/eservice/knowledgeConfig/saveScene`,
  cepPath: `/FHH/EM1HESERVICE2/eservice/knowledgeConfig/saveScene`,
});
// 获得知识标签
register({
  methodName: 'findKnowledgeTagInfo',
  type: 'get',
  publicPath: `${baseUrl}/findKnowledgeTagInfo`,
  cepPath: `${cepBaseUrl}/findKnowledgeTagInfo`,
});
// 获取水印
register({
  methodName: 'getPreviewWatermark',
  type: 'get',
  publicPath: `${baseUrl}/getPreviewWatermark`,
  cepPath: `${cepBaseUrl}/getPreviewWatermark`,
});
// 获取水印(新)
register({
  methodName: 'getPreviewWatermarkConfig',
  type: 'get',
  publicPath: `${baseUrl}/getPreviewWatermarkConfig`,
  cepPath: `${cepBaseUrl}/getPreviewWatermarkConfig`,
});
// 获取配置
register({
  methodName: 'serviceKnowledgeConfig',
  type: 'post',
  publicPath: `${baseUrl}/serviceKnowledgeConfig`,
  cepPath: `${cepBaseUrl}/serviceKnowledgeConfig`,
});
// 增加附件操作记录预览、下载数量
register({
  methodName: 'increaseAttachmentRecordCount',
  type: 'post',
  publicPath: `${baseUrl}/increaseAttachmentRecordCount`,
  cepPath: `${cepBaseUrl}/increaseAttachmentRecordCount`,
});
// 校验是否需要跳转下游
register({
  methodName: 'isOuter',
  type: 'post',
  publicPath: `${cepBaseUrl}/isOuter`,
  cepPath: `${cepBaseUrl}/isOuter`,
});

/************************* 有权限的接口调用 **********************************/
// 获取知识记录
register({
  methodName: 'cepQueryKnowledgeRecordH5',
  type: 'post',
  publicPath: `${cepBaseUrl}/queryKnowledgeRecordH5`,
  cepPath: `${cepBaseUrl}/queryKnowledgeRecordH5`,
});
// 获取知识记录阅读、帮助等计数
register({
  methodName: 'cepUpdateKnowledgeRecordCount',
  type: 'post',
  publicPath: `${cepBaseUrl}/updateKnowledgeRecordCount`,
  cepPath: `${cepBaseUrl}/updateKnowledgeRecordCount`,
});
// 获取知识详情
register({
  methodName: 'cepQueryKnowledgeRecordDetail',
  type: 'post',
  publicPath: `${cepBaseUrl}/queryKnowledgeRecordDetail`,
  cepPath: `${cepBaseUrl}/queryKnowledgeRecordDetail`,
});
// 获取最新最热
register({
  methodName: 'cepQueryMaxKnowledge',
  type: 'post',
  publicPath: `${cepBaseUrl}/queryMaxKnowledge`,
  cepPath: `${cepBaseUrl}/queryMaxKnowledge`,
});
// 获取知识分类（话术库）
register({
  methodName: 'cepQueryCategoryByScene',
  type: 'post',
  publicPath: `${cepBaseUrl}/queryCategoryByScene`,
  cepPath: `${cepBaseUrl}/queryCategoryByScene`,
});
// 更新知识分类顺序
register({
  methodName: 'cepCustomOrderCategory',
  type: 'post',
  publicPath: `${cepBaseUrl}/customOrderCategory`,
  cepPath: `${cepBaseUrl}/customOrderCategory`,
});
// 添加知识分类
register({
  methodName: 'cepAddCategory',
  type: 'post',
  publicPath: `/FHH/EM1HNCRM/API/v1/object/knowledge_category/service/add`,
  cepPath: `/FHH/EM1HNCRM/API/v1/object/knowledge_category/service/add`,
});
// 知识库配置
register({
  methodName: 'cepServiceKnowledgeConfig',
  type: 'post',
  publicPath: `/FHH/EM1HESERVICE2/eservice/knowledge/serviceKnowledgeConfig`,
  cepPath: `/FHH/EM1HESERVICE2/eservice/knowledge/serviceKnowledgeConfig`,
});
// 获取企业微信适配的富文本内容
register({
  methodName: 'cepGetRichHtmlForQywx',
  type: 'post',
  publicPath: `/FHH/EM1HESERVICE2/eservice/knowledge/getRichHtmlForQywx`,
  cepPath: `/FHH/EM1HESERVICE2/eservice/knowledge/getRichHtmlForQywx`,
});
// 获取轮询任务结果
register({
  methodName: 'cepGetPollingJobResult',
  type: 'post',
  publicPath: `/FHH/EM1HESERVICE2/eservice/service/polling/getPollingJobResult`,
  cepPath: `/FHH/EM1HESERVICE2/eservice/service/polling/getPollingJobResult`,
});

// 获得知识标签
register({
  methodName: 'cepFindKnowledgeTagInfo',
  type: 'get',
  publicPath: `${cepBaseUrl}/findKnowledgeTagInfo`,
  cepPath: `${cepBaseUrl}/findKnowledgeTagInfo`,
});
// 获取水印
register({
  methodName: 'cepGetPreviewWatermark',
  type: 'get',
  publicPath: `${cepBaseUrl}/getPreviewWatermark`,
  cepPath: `${cepBaseUrl}/getPreviewWatermark`,
});
// 获取水印(新)
register({
  methodName: 'cepGetPreviewWatermarkConfig',
  type: 'get',
  publicPath: `${cepBaseUrl}/getPreviewWatermarkConfig`,
  cepPath: `${cepBaseUrl}/getPreviewWatermarkConfig`,
});
// 获取配置
register({
  methodName: 'cepServiceKnowledgeConfig',
  type: 'post',
  publicPath: `${cepBaseUrl}/serviceKnowledgeConfig`,
  cepPath: `${cepBaseUrl}/serviceKnowledgeConfig`,
});
// 获取所有开启的场景 5.8.0
register({
  methodName: 'cepGetScenes',
  type: 'post',
  publicPath: `${cepBaseUrl}Config/getNewSceneList`,
  cepPath: `${cepBaseUrl}Config/getNewSceneList`,
});
// 批量删除知识记录
register({
  methodName: 'cepBatchDeleteArticle',
  type: 'post',
  publicPath: `/FHH/EM1HNCRM/API/v1/object/ServiceKnowledgeObj/action/AsyncBulkInvalid`,
  cepPath: `/FHH/EM1HNCRM/API/v1/object/ServiceKnowledgeObj/action/AsyncBulkInvalid`,
});
// 根据对象APINAME获取对象描述
register({
  methodName: 'findDescribeByApiName',
  type: 'post',
  publicPath: `/FHH/EM1HNCRM/API/v1/object/describe/service/findDescribeByApiName`,
  cepPath: `/FHH/EM1HNCRM/API/v1/object/describe/service/findDescribeByApiName`,
});

export default methods;
